<template>
  <div class="visit">
    <!-- 搜索框 -->
    <SearchBar @search="search" :checkList="checkList" />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
      @expand-change="handleExpand"
      lazy
      :height="560"
    >
      <!-- hasChildren: 'hasChildren'  -->
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
            :data="props.row.subTableData"
            :default-expand-all="true"
            stripe
            fit
            :show-header="true"
            class="childTable"
          >
            <el-table-column label="楼盘名" align="center">
              <template slot-scope="scope">
                {{ scope.row.house && scope.row.house.houseName }}
              </template>
            </el-table-column>

            <el-table-column label="推荐人" align="center">
              <template slot-scope="scope">
                <span>{{ handledecrypt(scope.row.reward) || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="客户名" align="center">
              <template slot-scope="scope">
                {{ handledecrypt(scope.row.customerName) || '--' }}
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="客户电话"
              align="center"
            >
              <template slot-scope="scope">
                {{ handledecrypt(scope.row.customerPhone) || '--' }}
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="身份证号码"
              align="center"
            >
              <template slot-scope="scope">
                {{ handledecrypt(scope.row.lastSixId) || '--' }}
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="销售员"
              align="center"
            >
              <template slot-scope="scope">
                {{ handledecrypt(scope.row.salesPersonName) || '--' }}
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="客服"
              align="center"
            >
              <template slot-scope="scope">
                {{ handledecrypt(scope.row.customerServiceName) || '--' }}
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="状态"
              align="center"
            >
              <template slot-scope="scope">
                {{ statusList[scope.row.status] }}
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="看房时间"
              align="center"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.appointmentTime.split(' ')[0] || '' }}</div>
                <div>{{ scope.row.appointmentTime.split(' ')[1] || '' }}</div>
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="修改人"
              align="center"
            >
              <template slot-scope="scope" v-if="scope.row.update">
                {{ scope.row.update.userName || '--' }}
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="修改时间"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.reviewTime !== null">
                  {{ scope.row.reviewTime.split(' ')[0] }}
                </div>
                <div v-if="scope.row.reviewTime !== null">
                  {{ scope.row.reviewTime.split(' ')[1] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              class-name="status-col"
              label="修改备注"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.reviewOpinion || '--' }}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <el-table-column label="邀请人" align="center">
        <template slot-scope="scope">
          <span>{{ handledecrypt(scope.row.inviteUserName) || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="经纪人" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.nickName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="经纪人电话"
        align="center"
      >
        <template slot-scope="scope">
          {{
            handledecrypt(
              scope.row.mobile,
              scope.row.isShowAllPhone,
              'phone'
            ) || '--'
          }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="身份类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.certType || '--' }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="身份证号码"
        align="center"
      >
        <template slot-scope="scope">
          {{
            handledecrypt(
              scope.row.certNumber,
              scope.row.isShowAllCertNumber,
              'cert'
            ) || '--'
          }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="身份证人像面"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <img :src="scope.row.certFrontImg" width="200" height="200" /> -->
          <el-image
            v-if="scope.row.certFrontImg"
            style="width: 100px; height: 100px"
            :src="
              handledecrypt(
                scope.row.certFrontImg,
                scope.row.isShowAllCertImg,
                'img'
              )
            "
            :preview-src-list="[
              handledecrypt(
                scope.row.certFrontImg,
                scope.row.isShowAllCertImg,
                'img'
              ),
            ]"
          >
          </el-image>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="身份证国徽面"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <img :src="scope.row.certBackImg" width="200" height="200" /> -->
          <el-image
            v-if="scope.row.certBackImg"
            style="width: 100px; height: 100px"
            :src="
              handledecrypt(
                scope.row.certBackImg,
                scope.row.isShowAllCertImg,
                'img'
              )
            "
            :preview-src-list="[
              handledecrypt(
                scope.row.certBackImg,
                scope.row.isShowAllCertImg,
                'img'
              ),
            ]"
          >
          </el-image>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="银行名称" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.bankName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="银行卡号" align="center">
        <template slot-scope="scope">
          {{
            handledecrypt(
              scope.row.bankNumber,
              scope.row.isShowAllBankNumber,
              'bank'
            ) || '--'
          }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="注册时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.creationTime || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="用户状态" align="center">
        <template slot-scope="scope">
          {{ scope.row.status == 0 ? '正常' : '已注销' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <!-- 修改状态 -->
    <changeStatus ref="changeStatus" @fetchData="fetchData" />

    <manualAllocation ref="manualAllocation" @fetchData="fetchData" />

    <!-- 查看详情 -->
    <!--  v-if="detailObj" -->
    <!-- class="detail" -->
    <el-dialog
      title="详情"
      class="detail"
      :visible.sync="detailShow"
      width="30%"
    >
      <div class="detail-row">
        <span>备注: </span>{{ detailObj.reviewOpinion }}
      </div>
      <div class="detail-row">
        <span>到访时间:</span> {{ detailObj.arriveTime }}
      </div>
      <div class="detail-row">
        <span> 签约时间:</span> {{ detailObj.signedTime }}
      </div>
      <div class="detail-row">
        <span> 成交类型:</span> {{ detailObj.type === 1 ? '购' : '租' }}
      </div>
      <div class="detail-row">
        <span> 单价:</span> {{ detailObj.unitPrice }}
      </div>
      <div class="detail-row">
        <span> 总佣金:</span> {{ detailObj.totalBonus }}
      </div>
      <div class="detail-row">
        <span> 成交金额:</span> {{ detailObj.totalPrice }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAgentSerApi } from '@/api/agent';
import { getUserListApi } from '@/api/introduce';
const changeStatus = () => import('./components/changeStatus'); // 增加表单
const manualAllocation = () => import('./components/manualAllocation');
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import SearchBar from './components/searchBar'; // 搜索框
import { decrypt } from '@/utils/encryp';
import { getLastMonthTimeRange } from '@/utils';

export default {
  components: {
    changeStatus,
    manualAllocation,
    Pagination,
    SearchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      detailShow: false,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      detailObj: {}, // 详情数据
      checkList: [], // 选中的列表
      subTableData: [],
      currentUserId: '',
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    document.querySelector('.el-table__body-wrapper').style.height = '580px';
  },

  computed: {
    ...mapGetters(['paginObj', 'statusList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str, isShowAll = true, type = '') {
      // // if (!str || str.indexOf('=') == -1) return str;

      let showStr = decrypt(str);
      if (type === 'phone') {
        return isShowAll
          ? showStr
          : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
      } else if (type === 'cert') {
        return isShowAll
          ? showStr
          : showStr.replace(/^(.{6})(?:\d+).(.{4})$/, '$1****$2');
      } else if (type === 'bank') {
        return isShowAll
          ? showStr
          : showStr.replace(/^(.{4})(?:\d+)(.{4})$/, '$1 **** **** $2');
      } else if (type === 'img') {
        return isShowAll
          ? showStr
          : 'https://osstest.9n1m.com/startearn-test/2022/11/25/0cda78656cd1417188a87130ad5e62f0.png';
      } else {
        return showStr;
      }
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData() {
      // console.log('分页：', this.paginObj);

      try {
        const timeRange = getLastMonthTimeRange();

        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        this.listLoading = true;
        let res = await getAgentSerApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          areaId,
          creationStartTime: timeRange[0],
          creationEndTime: timeRange[1],
          ...this.fromSearchObj,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        if (this.list && this.list.length) {
          this.fetchSubData(dataList[0].userId, dataList);
        }
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },
    // 展开行
    async handleExpand(row, expandedRows) {
      console.log('展开行', expandedRows);
      if (!expandedRows.length) return;
      // 当前行row 展开的所有行expandedRows
      this.fetchSubData(row.userId, this.list);
    },
    async fetchSubData(userId, list) {
      try {
        this.listLoading = true;
        let res = await getUserListApi({
          pageSize: 1000,
          pageIndex: 1,
          userId,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { dataList } = res.data;
        list.length &&
          list.map((item) => {
            if (item.userId == userId) {
              item.subTableData = dataList;
            } else {
              item.subTableData = [];
            }
          });
        this.list = list;
        console.log('subData', this.list);
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },
    // 加载子表格数据
    async loadSubData(tree, treeNode, resolve) {
      console.log('加载子表格数据', tree, treeNode);
      try {
        this.listLoading = true;
        let res = await getUserListApi({
          pageSize: 1000,
          pageIndex: 1,
          userId: this.currentUserId,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { dataList } = res.data;
        // this.list.length &&
        //   this.list.map((item) => {
        //     if (item.userId == userId) {
        //       item.subTableData = dataList;
        //     }
        //   });
        // console.log('subData', this.list);
        resolve(dataList);
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      // pageSize=20&pageIndex=1&userId=2ac90720-4dee-436d-a513-2f541f71da6f&salerName=&mobile=&inviteUserId=2ac90720-4dee-436d-a513-2f541f71da6f
      const {
        salerName,
        mobile,
        inviteUserId,
        creationStartTime,
        creationEndTime,
      } = obj;
      if (obj)
        this.fromSearchObj = {
          salerName,
          mobile,
          inviteUserId,
          creationStartTime,
          creationEndTime,
        };
      // 重置页码
      this.$store.dispatch('area/setPaginObj', {
        pageIndex: 1,
        pageSize: 20,
      });
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.userId;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.visit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
/deep/ .el-table__body-wrapper {
  height: 660px !important;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.btn {
  margin-bottom: 10px;
}

.lookDetails {
  margin-top: 10px;
}

.detail {
  .detail-row {
    margin-top: 10px;
    display: flex;
    font-size: 16px;

    span {
      width: 100px;
      text-align: right;
      margin-right: 20px;
      font-weight: 550;
    }
  }
}
</style>
